import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=52b7a678&scoped=true&"
var script = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=52b7a678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7a678",
  null
  
)

export default component.exports